import React from 'react';
import './Resume.css';

const Resume = () => {
  return (
    <div className="resume-section">
      <div className="resume-header">
        <h1>RESUME</h1>
      </div>
      <div className="resume-body">
        <div className="resume-experience">
          <h2>PRESENT</h2>
          <div className="timeline">
            <div className="timeline-entry">
              <div className="timeline-date">09/2023</div>
              <div className="timeline-content">
                <h3>Aston Martin F1 Team, Silverstone, United Kingdom</h3>
                <p>Graduate Software Engineer, Car Performance, Tools & Visualization.</p>
              </div>
            </div>
            <div className="timeline-entry">
              <div className="timeline-date">08/2023 <br/> 05/2023</div>
              <div className="timeline-content">
                <h3>Santander Global Technology, Malaga, Spain</h3>
                <p>Software Engineering Analyst, Finance Control</p>
              </div>
            </div>
            <div className="timeline-entry">
            <div className="timeline-date">05/2023 <br/> 09/2018</div>
              <div className="timeline-content">
                <h3>University of Strathclyde, Glasgow, Scotland</h3>
                <p>Graduated with First Class Honours <br/> (B.Eng Software Engineering)</p>
              </div>
            </div>
            <div className="timeline-entry">
            <div className="timeline-date">06/2022 <br/> 06/2021</div>
            <div className="timeline-content">
                <h3>The Walt Disney Company, London, England</h3>
                <p>Technical Engineer Intern</p>
              </div>
            </div>
            {/* Add other timeline entries here */}
          </div>
        </div>
        <div className="resume-awards">
          <h2>AWARDS AND CERTIFICATIONS</h2>
          <ul>
            <li>ScotlandIs Young Software Engineer of the Year 2023</li>
            <li>University of Strathclyde Charles Babbage Prize <br></br>
            for Best Project in the CIS Department 2023</li>
            <li>AWS Certified Cloud Practicioner</li>
            {/* Add other awards and certifications here */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Resume;
